import { Image, Card, Tabs } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import EllipsisText from "react-ellipsis-text";
import Col from "reactstrap/lib/Col";
import Row from "reactstrap/lib/Row";
import { getAgeFromDOB } from "Utils/GetAgeFromDOB";
import { getLabPackageDetails } from "Utils/Services/Lab/LabPackages";

const { TabPane } = Tabs;

const PackageDetailsCard = ({ id }) => {
  const [data, setData] = useState("");

  

  useEffect(() => {
    const getData = async () => {
      const result = await getLabPackageDetails({
        package_id: +id,
      });
      result && setData(result?.pakage[0]);
    };
    if (id) {
      getData();
    }
  }, [id]);

  const AppointmentTab = () => {
    return (
      <div className="general-info">
        <Row lg="9" md="12" sm="12">
          <Col lg="4" md="4" sm="6" className="item">
            <h4 className="label-gray">Package Price</h4>
            <h4 className="text-black">₹{data?.price ? data.price : ""}</h4>
          </Col>
          <Col lg="4" md="4" sm="6" className="item">
            <h4 className="label-gray">Package Active</h4>
            <h4 className="text-black">
              {data?.active_flag === 1 ? "Yes" : "No"}
            </h4>
          </Col>
          <Col lg="4" md="4" sm="6" className="item">
            <h4 className="label-gray">Created At</h4>
            <h4 className="text-black">
              {data?.created_at
                ? moment(data.created_at).format("DD-MMM-yyyy hh:mm")
                : ""}
            </h4>
          </Col>
        </Row>
        <Card style={{ width: "100%" }}>
          <div className="details-wraper">
            <label>Sample At Home:</label>
            <h4 className="text">
              {data?.sample_at_home
                ? data?.sample_at_home === "1"
                  ? "Yes"
                  : "No"
                : ""}
            </h4>
          </div>
          <div className="details-wraper">
            <label>Offer Start Date:</label>
            <h4 className="text">
              {data?.offer_start_dt
                ? moment(data.offer_start_dt).format("DD-MMM-yyyy hh:mm")
                : ""}
            </h4>
          </div>
          <div className="details-wraper">
            <label>Promotion Text:</label>
            <h4 className="text">
              {data?.promotion_text ? data.promotion_text : ""}
            </h4>
          </div>
          <div className="details-wraper">
            <label>Available Tests:</label>
            <h4 className="text">
              {data?.available_tests_ids
                ? data?.available_tests_ids.map((test) => (
                    <span key={test} style={{ marginLeft: "5px" }}>
                      {test},
                    </span>
                  ))
                : ""}
            </h4>
          </div>
          <div className="details-wraper">
            <label>Package Categories:</label>
            <h4 className="text">
              {data?.package_category_ids
                ? data?.package_category_ids.map((category) => (
                    <span key={category} style={{ marginLeft: "5px" }}>
                      {category},
                    </span>
                  ))
                : ""}
            </h4>
          </div>
          <div className="details-wraper">
            <label>Discount: </label>
            <h4 className="text">{data?.discount ? data.discount : ""}</h4>
          </div>

          {data?.cancelled_time && (
            <>
              <div className="details-wraper">
                <label>Cancelled Time:</label>
                <h4 className="text">
                  {data?.cancelled_time ? data.cancelled_time : ""}
                </h4>
              </div>
              <div className="details-wraper">
                <label>Cancelled User:</label>
                <h4 className="text">
                  {data?.cancelled_user ? data.cancelled_user : ""}
                </h4>
              </div>
            </>
          )}
        </Card>
      </div>
    );
  };

  return (
    <div className="table-item-details-card p-6">
      <div className="profile-info">
        <div
          className="profile-image"
          style={{ backgroundImage: `url(${data?.package_image})` }}
        />
        <div className="appointment-id" style={{ width: "fit-content" }}>
          Id: {data?.package_id}
        </div>
        <h4
          className="mt-2"
          style={{ textTransform: "capitalize", paddingBottom: "10px" }}
        >
          <EllipsisText
            text={data?.package_name ? data.package_name : " "}
            length={50}
          />
        </h4>
        {data.dob && data.dob !== "" && (
          <div className="dob-wrapper">
            <span className="label">Dob:</span>
            <span className="dob">{data.dob}</span>
          </div>
        )}
        {data.dob && data.dob !== "" && (
          <div className="dob-wrapper">
            <span className="label">Age:</span>
            <span className="dob">{data?.dob && getAgeFromDOB(data?.dob)}</span>
          </div>
        )}
      </div>
      <div className="details-tab-container tab-style">
        <Tabs type="card" defaultActiveKey="1">
          <TabPane tab="Details" key="1">
            <AppointmentTab />
          </TabPane>

          <TabPane tab="Gallery" key="2">
            <div className="prescription-container">
              {Array.isArray(data?.package_gallery) &&
                data?.package_gallery.map((img) => (
                  <Image
                    width={80}
                    height={80}
                    src={img}
                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                  />
                ))}
            </div>
          </TabPane>
          <TabPane tab="About" key="3">
            <div
              dangerouslySetInnerHTML={{ __html: data?.about_package }}
            ></div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};
export default PackageDetailsCard;
